import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        bills: {data: [], current_page: 1, total: 0, per_page: 10},
        bill: {},
        bill_review: {tenancies: [], sms_balance: 0, sms_units_needed: 0, property_id: null, period_start: null},
        reviewing: false,
        sending: false,
        send_result: null,
        loading: false,
        errors: {
            data: {
                errors: {
                    amount: [],
                    description: [],
                    bill_date: [],
                    amount_paid: [],
                    date_paid: [],
                    tps_detail_id: [],
                    penalty_id: [],
                    charge_id: [],
                    tenancy_id: []

                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        bills: state => state.bills,
        bill: state => state.bill,
        bill_review: state => state.bill_review,
        reviewing: state => state.reviewing,
        sending: state => state.sending,
        send_result: state => state.send_result,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setReviewing(state, val) {
            state.reviewing = val
        },
        setSending(state, val) {
            state.sending = val
        },
        setSendResult(state, data) {
            state.send_result = data
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setBills(state, data) {
            state.bills = data;
        },
        setBill(state, data) {
            state.bill = data;
        },
        setBillReview(state, data) {
            state.bill_review = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            amount: [],
                            description: [],
                            bill_date: [],
                            amount_paid: [],
                            date_paid: [],
                            tps_detail_id: [],
                            penalty_id: [],
                            charge_id: [],
                            tenancy_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getBills({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getBills(filters);
                commit('setBills', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e?.response?.data?.message || 'Error fetching bills');
            }
        },

        async getBill({commit}, id) {
            try {
                commit('setLoading', true)
                const response = await api.getBill(id);
                commit('setBill', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e?.response?.data?.message || 'Error fetching bill');
            }
        },
        async createBill({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                const response = await api.createBill(data);
                ElMessage.success({
                    message: response.message,
                    duration: 10000
                });
                window.location.href = '/bills'
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editBill({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editBill(data);
                dispatch('getBills', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteBill({dispatch}, data) {
            try {
                await api.deleteBill(data);
                dispatch('getBills', {
                    paginate: true
                })
                ElMessage.success("Bill removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Bill');
                }
            }
        },

        async getBillsReview({commit}, filters) {
            commit('setReviewing', true);
            try {
                const response = await api.getBillsReview(filters);
                commit('setBillReview', response);
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
            commit('setReviewing', false);
        },

        async sendBills({commit, dispatch}, data) {
            commit('setSending', true);
            commit('setSendResult', null);
            try {
                const response = await api.sendBills(data);
                commit('setSendResult', {status: 'sent', ...response.data});
                ElMessage.success(response.message);
                dispatch('getBillsReview', {
                    property_id: data.property_id,
                    period_start: data.period_start
                });
            } catch (e) {
                if (e.response && e.response.status === 422 && e.response.data?.data?.status === 'insufficient_balance') {
                    commit('setSendResult', {status: 'insufficient_balance', ...e.response.data.data});
                } else {
                    ElMessage.error(e.response?.data?.message || 'Error sending bills');
                }
            }
            commit('setSending', false);
        },

        async exportBillsReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportBillsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Bills_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        }
    }
}
